var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-title-page"},[_c('div',{staticClass:"title-wrapper"},[_c('pods-input',{ref:"podsInput"}),_c('span',{staticClass:"title"},[_vm._v("Chart View")])],1),_c('div',{staticClass:"mb-20 mt-20",class:_vm.screenWidth > 1023 ? 'text-right' : 'text-left'},[_c('UtcOffsets')],1),_c('div',{staticClass:"mt-10",style:({
      width: '100%',
      height: '600px'
    }),attrs:{"id":"chart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }